import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import React, { useContext } from 'react';
import { toFormattedDataItem } from 'widgets/historicalPercentageChange/capsule/components/formattedDataItem.ts';
import AppContext from 'app/AppContext.tsx';

import './HistoricalPercentageChangeCapsuleBack.scss';
import classNames from 'classnames';

export function HistoricalPercentageChangeCapsuleBack({
    averageVolume,
    selectedItem,
}: {
    averageVolume?: number;
    selectedItem?: HistoricalPercentageChangeDataItem;
}) {
    const { numberFormat } = useContext(AppContext);

    if (!selectedItem) {
        return <></>;
    }

    const formatted = toFormattedDataItem(
        averageVolume,
        selectedItem,
        numberFormat
    )!;
    const percentClassNames = classNames(
        'percent',
        formatted.percentPositive ? 'up' : 'down'
    );

    return (
        <div className="HistoricalPercentageChangeCapsuleBack">
            <div className="date">{formatted.date}</div>
            <div className="capsule-values">
                <div className="price">
                    <div className="label">Price</div>
                    <div className="value">{formatted.price}</div>
                </div>
                <div className={percentClassNames}>
                    <div className="label">% Change</div>
                    <div className="value">{formatted.percent}</div>
                </div>
                <div className="volume">
                    <div className="label">Volume</div>
                    <div className="value">{formatted.volume}</div>
                </div>
                <div className="average-volume">
                    <div className="label">AverageVolume</div>
                    <div className="value">{formatted.averageVolume}</div>
                </div>
            </div>
        </div>
    );
}
